const AwsAccess = {
    // apiPath: "https://a4iizsy098.execute-api.us-west-2.amazonaws.com/prod",
    apiPath: "https://api.domenic-aws.info",
}

export default AwsAccess;